import {
  requestProducts,
  receiveProducts,
  moreProductsLoaded,
  previousProductsLoaded,
  loadingPreviousProducts,
  loadingMoreProducts,
  restoreOldSelectedFacets,
  updatePersonalisationParams,
  setAdditionalQueryParams,
  updateAdditionalQueryParams,
  updateMultiFacet,
  dismissFloorFilter,
  clearSelections,
  setNewSearch,
  clearNewSearch,
  refreshAdvertisementBeacons
} from "./actionCreators";

import applyFacets from "../filters/thunks/apply";
import { CATEGORY_PAGE } from "../../../page/constants";

export { default as clear } from "../filters/thunks/clear";
export { default as clearAlwaysApply } from "../filters/thunks/clearAlwaysApply";
export { default as clearAll } from "../filters/thunks/clearAll";
export { default as selectAll } from "../filters/thunks/selectAll";
export { default as applyFacets } from "../filters/thunks/apply";
export { default as done } from "../filters/thunks/done";
export { undoSearch } from "../undo";
export {
  changeMultiFacet,
  dismissFloorDeselections,
  changeMultiFacetAndApplyIfLargeMedium,
  changeSort
} from "../filters/thunks";
export {
  sendPlacementOnViewBeacon,
  sendPlacementOnLoadBeacon
} from "../diagnostics/thunks";
export {
  loadPreviousThunk,
  loadMoreThunk,
  loadPrevious,
  loadMore
} from "../results/thunks";
export {
  updateRangeFacet,
  setNextPriceRangeToCurrent,
  changeRangeFacet,
  applyRangeFacet,
  clearRangeFacet
} from "../priceRange/thunks";
export { updateImageGalleryOnboardDismissed } from "../ui/thunks";
export {
  fetchSearchThunk,
  fetchCategoryThunk,
  fetchSearch,
  fetchCategory,
  getSearchAction,
  getSearchActionCreator
} from "../query/thunks";
import { loadPreviousThunk, loadMoreThunk } from "../results/thunks";
import { fetchSearchThunk, fetchCategoryThunk } from "../query/thunks";

export {
  requestProducts,
  receiveProducts,
  moreProductsLoaded,
  previousProductsLoaded,
  loadingPreviousProducts,
  loadingMoreProducts,
  restoreOldSelectedFacets,
  updatePersonalisationParams,
  setAdditionalQueryParams,
  updateAdditionalQueryParams,
  updateMultiFacet,
  dismissFloorFilter,
  clearSelections,
  setNewSearch,
  clearNewSearch,
  refreshAdvertisementBeacons
};

const getFetchAction = ({ page: { name: pageName } }) =>
  pageName === CATEGORY_PAGE ? fetchCategoryThunk() : fetchSearchThunk();

const reapplyFacets = () => dispatch => {
  dispatch(restoreOldSelectedFacets());
  dispatch(applyFacets());
};

export function retrySearch({ actionType, forceReapplyFacets } = {}) {
  return (dispatch, getState) => {
    switch (actionType) {
      case previousProductsLoaded.type:
        dispatch(loadPreviousThunk());
        break;
      case moreProductsLoaded.type:
        dispatch(loadMoreThunk());
        break;
      default:
        forceReapplyFacets
          ? dispatch(reapplyFacets())
          : dispatch(getFetchAction(getState()));
        break;
    }
  };
}
